import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { bgColor } from "../../../../../utility/constants/colorManager";
import "./pagination.css";
import { DOTS, usePagination } from "./usePagination";

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    totalPages,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  const onNext = () => {
    if (currentPage !== lastPage) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage >= 2) {
      onPageChange(currentPage - 1);
    }
  };

  let lastPage = paginationRange[paginationRange?.length - 1];

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px 30px",
        boxSizing: "border-box",
        backgroundColor: "white",
        borderTop: "1px solid #f3f3f3",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <FaChevronLeft
          size={12}
          style={{
            color: currentPage === 1 ? "#939393" : "#1C1C1C",
            cursor: "pointer",
          }}
          onClick={onPrevious}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0px 20px",
          }}
        >
          {paginationRange.map((pageNumber, index) => {
            if (pageNumber === DOTS) {
              return (
                <li className="pagination-item dots" key={index}>
                  <p
                    style={{
                      letterSpacing: 3,
                      color: "grey",
                    }}
                  >
                    ....
                  </p>
                </li>
              );
            }

            return (
              <li
                key={index}
                style={{
                  backgroundColor:
                    pageNumber === currentPage ? "#D6E4E5" : "white",
                  borderRadius: 5,
                  height: 28,
                  minWidth: 28,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 18,
                  cursor: "pointer",
                  color: "#1c1c1c",
                  marginLeft: 10,
                  marginRight: 10,
                }}
                onClick={() => onPageChange(pageNumber)}
              >
                <p style={{ fontSize: 13 }}> {pageNumber} </p>
              </li>
            );
          })}
        </div>
        <FaChevronRight
          size={12}
          style={{
            color: currentPage === totalPages ? "#939393" : "#1C1C1C",
            cursor: "pointer",
          }}
          onClick={onNext}
        />
      </div>
    </div>
  );
};

export default Pagination;
